<template>
  <div>
    <button>計算</button>
    <slot></slot>
    <div>{{calculate}}</div>
  </div>
</template>

<script>
export default {
  props:{
    weight:Number,
    height:Number
  },
  computed:{
    calculate: function() {
      return this.weight + this.height;
    }
  }
}
</script>

<style scoped>

</style>